import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faUsers } from '@fortawesome/free-solid-svg-icons';
import Circles from '../../assets/images/circle.png';
import axios from "axios";
import { useState, useEffect, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import * as XLSX from 'xlsx';
import SurveyDataTableView from "./SurveyDataTableView";
import { getSurveyDataTableView } from "./surveyDataTableViewResp";


function SurveyData() {
  const [isFetching, setIsFetching] = useState(true);
  const [surveyData, setsurveyData] = useState([]);
  const [surveySchemeData, setsurveySchemeData] = useState([]);
  const [activeTab, setActiveTab] = useState("dashboard");
  const [backButtonStatus, setBackButtonStatus] = useState('dashboard');
  const [loading, setLoading] = useState(false);
  const [showNFSMCards, setShowNFSMCards] = useState(false);
  const [showATMACards, setShowATMAards] = useState(false);
  const [showMOVCDCards, setShowMOVCDCards] = useState(false);
  const [showMIDHCards, setShowMIDHCards] = useState(false);
   const [showRKVYCards, setShowRKVYCards] = useState(false);
  const [LoaderSurveyData, setLoaderSurveyData] = useState(false);


  const [selectedState, setSelectedState] = useState("");

  // Filter states
  const [statesData, setStatesData] = useState([]);
  const [districtData, setDistrictData] = useState([]);
  const [districtValue, setDistrictValue] = useState("");
  const [finacialYearValue, setFinacialYearValue] = useState("");
  const handleFinancialYearChange = (e) => {
    setFinacialYearValue(e.target.value);
  };
  const [selectedSchemeWiseData, setSelectedSchemeWiseData] = useState("");
  const [selectedUmbrellaBasedData, setSelectedUmbrellaBasedData] = useState("");

  const handleSchemeWiseChange = (e) => {
    setSelectedSchemeWiseData(e.target.value);
  };
  const handleUmbrellaBased = (e) => {
    setSelectedUmbrellaBasedData(e.target.value);
  };
  const [subDistrictData, setSubDistrictData] = useState([]);
  const [villageData, setVillageData] = useState([]);
  const [blockData, setBlockData] = useState([]);
  const [stateValue, setStateValue] = useState('');
  const [blockValue, setBlockValue] = useState("");
  const [subDistrictValue, setSubDistrictValue] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [villageValue, setVillageValue] = useState("");
  const [statusValue, setStatusValue] = useState("");
  const [surveyTableData, setSurveyTableData] = useState(null);
  const [selectedSubDistrict, setSelectedSubDistrict] = useState("");
  const [selectedBlock, setSelectedBlock] = useState("");
  const [selectedVillage, setSelectedVillage] = useState("");
  const [selectedScheme, setSelectedScheme] = useState("");
  const [stateCodeValue, setStateCodeValue] = useState("");

  const [selectedSateScheme, setSelectedSateScheme] = useState("");
  const [selectedSchemeData, setSelectedSchemeData] = useState([]);
  const [selectedSateData, setSelectedSateData] = useState([]);
  const [loadingExcel, setLoadingExcel] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    fetchData();
    fetchSchemeData();
    // fetchSchemeDataDetails();
  }, []);

  useEffect(() => {
    if (surveyData.length > 0) {
      console.log("Updated surveyData:", surveyData);
    }
  }, [surveyData]);

  const fetchData = async () => {
    setLoaderSurveyData(true);
    setsurveyData([]);
    let result;
    result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSchemeCount`, {}
    );
    if (result.data.success === true) {
      setsurveyData(result.data.dataContent); // Set state here
      console.log("Data", result.data.dataContent);
      console.log("Data11", surveyData);
      setIsFetching(false);
      setLoaderSurveyData(false);
    }
  };

  const fetchSchemeData = async () => {

    setsurveySchemeData([]);
    const stateCode = stateValue ? String(stateValue) : "0";
    const districtCode = districtValue ? String(districtValue) : "0";
    let result;
    result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSchemeCount`, {
      "flag": 1,
      "schemeName": selectedSchemeWiseData,
      "stateCode": stateCode,
      "districtCode": districtCode,
      "financialYear": finacialYearValue
    }
    );
    if (result.data.success === true) {
      setsurveySchemeData(result.data.dataContent); // Set state here
      console.log("Data", result.data.dataContent);
      console.log("Data11", surveyData);
      setIsFetching(false);
      setLoaderSurveyData(false);
    }
  };

  const NFSM_SCHEMES = [
    "(NFSM) SD",
    "(NFSM) CFLD",
    "(NFSM) FLD"
  
  ];

  const RKVY_SCHEMES = [
    "(RKVY DPR) SD",
    "(RKVY DPR) FLD",
    "(RKVY DPR) CFLD"
  
  ];

  const ATMA_SCHEMES = [
    "(ATMA) SD",
    "(ATMA) CFLD",
    "(ATMA) FLD"
  ];

  const MOVCD_SCHEMES= [
    "(MoVCD) SD",
    "(MoVCD) CFLD",
    "(MoVCD) FLD"
  ];

  const MIDH_SCHEMES= [
    "(MIDH) SD",
    "(MIDH) CFLD",
    "(MIDH) FLD"
  ];




  const rkvytotalSurvey = surveyData
    .filter(
      item =>
        selectedUmbrellaBasedData === "demostration" &&
        RKVY_SCHEMES.includes(item.schemeName)
    )
    .reduce((sum, item) => sum + Number(item.totalSurvey || 0), 0);

    const nfsmtotalSurvey = surveyData
    .filter(
      item =>
        selectedUmbrellaBasedData === "demostration" &&
        NFSM_SCHEMES.includes(item.schemeName)
    )
    .reduce((sum, item) => sum + Number(item.totalSurvey || 0), 0);

    const atmatotalSurvey = surveyData
    .filter(
      item =>
        selectedUmbrellaBasedData === "demostration" &&
        ATMA_SCHEMES.includes(item.schemeName)
    )
    .reduce((sum, item) => sum + Number(item.totalSurvey || 0), 0);

    const movcdtotalSurvey = surveyData
    .filter(
      item =>
        selectedUmbrellaBasedData === "demostration" &&
        MOVCD_SCHEMES.includes(item.schemeName)
    )
    .reduce((sum, item) => sum + Number(item.totalSurvey || 0), 0);
    
    const midhtotalSurvey = surveyData
    .filter(
      item =>
        selectedUmbrellaBasedData === "demostration" &&
        MIDH_SCHEMES.includes(item.schemeName)
    )
    .reduce((sum, item) => sum + Number(item.totalSurvey || 0), 0);

  function showNFSMCardsAction(){
    setShowNFSMCards(true);
    setShowATMAards(false);
    setShowMOVCDCards(false);
    setShowMIDHCards(false);
    setShowRKVYCards(false);
  }

  function showATMAardsAction(){
    setShowATMAards(true);
    setShowNFSMCards(false);
    setShowMOVCDCards(false);
    setShowMIDHCards(false);
    setShowRKVYCards(false);
  }
  function showMOVCDCardsAction(){
    setShowMOVCDCards(true);
    setShowATMAards(false);
    setShowNFSMCards(false);
    setShowMIDHCards(false);
    setShowRKVYCards(false);
  }
   function showMIDHCardsAction(){
    setShowMIDHCards(true);
    setShowATMAards(false);
    setShowNFSMCards(false);
    setShowMOVCDCards(false);
    setShowRKVYCards(false);
  }
  function showRKVYCardsAction(){
    setShowRKVYCards(true);
    setShowATMAards(false);
    setShowNFSMCards(false);
    setShowMOVCDCards(false);
    setShowMIDHCards(false);
  }

  const fetchSchemeDataInDetails = async (schemeName) => {
    setSelectedSchemeData([]);
    setLoaderSurveyData(true);
    const stateCode = stateValue ? String(stateValue) : "0";
    const districtCode = districtValue ? String(districtValue) : "0";
    let result;
    result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSchemeCount`, {
      "flag": 1,
      "SchemeName": schemeName,
      "stateCode": stateCode,
      "districtCode": districtCode,
      "financialYear": finacialYearValue
    }
    );
    if (result.data.success === true) {
      setSelectedSchemeData(result.data.dataContent); // Set state here
      setIsFetching(false);
      setLoaderSurveyData(false);
    }
  };

  function getdistrictWiseData(schemename, statecode, statename) {
    //alert(schemename+'---'+statecode)
    setStateCodeValue(statecode);
    setSelectedScheme(schemename);
    setSelectedSateScheme(statename);
    fetchStateDataInDetails(schemename, statecode)
    setActiveTab('districtWiseData');
    setBackButtonStatus('districtWiseData');
  }

  function getStatesWiseData(schemeName) {
    setSelectedScheme(schemeName);
    // alert(schemeName + '-------' + selectedScheme);
    fetchSchemeDataInDetails(schemeName)
    setActiveTab('stateWiseData');
    setBackButtonStatus('stateWiseData');
  }

  function backButton() {
    //alert(activeTab);
    if (activeTab === 'dashboard') {
      //navigate('/AdminAccess');
    } else if (activeTab === 'stateWiseData') {
      setActiveTab('dashboard');
    } else if (activeTab === 'districtWiseData') {
      setActiveTab('stateWiseData');
    } else if (activeTab === 'tableWiseData') {
      setActiveTab('dashboard');
    } else if (activeTab === 'demostration') {
      setActiveTab('dashboard');
    }

  };

  const fetchStateDataInDetails = async (schemeName, statecode) => {
    setSelectedSateData([]);
    setLoaderSurveyData(true);
    let result;
    result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSchemeCount`, {
      "flag": 1,
      "Schemename": schemeName,
      "statecode": statecode,
      "financialYear": finacialYearValue
    }
    );
    if (result.data.success === true) {
      setSelectedSateData(result.data.dataContent); // Set state here
      setIsFetching(false);
      setLoaderSurveyData(false);
    }
  };




  function handleState(value) {


    setStateValue(value);
    if (value === "NA") {
      return;
    }
    setDistrictData([]);
    setDistrictValue("");
    setSubDistrictValue("");

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      stateCode: Number(value),
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEV_MODE
        : process.env.REACT_APP_PRO_MODE
      }/api/district`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => setDistrictData(JSON.parse(result).dataContent))
      .catch((error) => console.log("error", error));
  }


  function getStates() {
    const fetchStates = async () => {
      const result = await axios(
        `${process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
        }/api/states`
      );
      setStatesData(result.data.dataContent);
    };
    fetchStates();
  }

  function resetFields() {
    setStateValue('');
    setDistrictValue('');
    setSubDistrictValue('');
    setBlockValue('');
    setVillageValue('');
    setStatusValue('');
    setSelectedSchemeWiseData('');
    setSelectedUmbrellaBasedData('');
    setFinacialYearValue('');
    fetchData();
    fetchSchemeData();
  }




  const exportToExcel = async () => {
    try {
      setLoadingExcel(true); // show loader

      const stateCode = stateValue ? String(stateValue) : "0";
      const districtCode = districtValue ? String(districtValue) : "0";

      // 🔹 API call
      let result = await axios.post(
        `${process.env.NODE_ENV === 'development'
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
        }/api/GT/GetSchemeCount`,
        {
          flag: 55,
          schemeName: selectedSchemeWiseData,
          stateCode: stateCode,
          districtCode: districtCode,
          financialYear: finacialYearValue,
        }
      );

      if (!result.data.success || !result.data.dataContent || result.data.dataContent.length === 0) {
        alert("No data found for export.");
        return;
      }

      const apiData = result.data.dataContent;

      // 🔹 Group data by scheme → state → district
      const grouped = {};
      apiData.forEach(item => {
        const scheme = item.schemeName;
        const state = item.stateName;
        const district = item.districtName;
        const total = Number(item.totalSurvey) || 0;

        if (!grouped[scheme]) grouped[scheme] = {};
        if (!grouped[scheme][state]) grouped[scheme][state] = { total: 0, districts: {} };

        grouped[scheme][state].total += total;
        grouped[scheme][state].districts[district] = total;
      });

      // 🔹 Prepare Excel sheet data
      let excelData = [];
      Object.keys(grouped).forEach(scheme => {
        excelData.push([`Scheme Name: ${scheme}`]); // Scheme header
        excelData.push([]); // Empty row

        excelData.push(["State Name", "Total Surveys"]); // State header
        Object.keys(grouped[scheme]).forEach(state => {
          const stateData = grouped[scheme][state];
          excelData.push([state, stateData.total]);

          // Add district breakdown
          excelData.push(["District Name", "Total Surveys"]);
          Object.keys(stateData.districts).forEach(district => {
            excelData.push([district, stateData.districts[district]]);
          });

          excelData.push([]); // space between states
        });

        excelData.push([]); // space between schemes
      });

      // 🔹 Create workbook & worksheet
      const ws = XLSX.utils.aoa_to_sheet(excelData);

      // Auto column width
      const colWidths = excelData[0].map((_, colIndex) => ({
        wch: Math.max(...excelData.map(row => (row[colIndex] ? row[colIndex].toString().length : 10)))
      }));
      ws['!cols'] = colWidths;

      // Create workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Survey Data");

      // 🔹 Export Excel file
      XLSX.writeFile(wb, "survey_data.xlsx");
    } catch (error) {
      console.error("Error exporting Excel:", error);
      alert("Failed to export Excel. Please try again.");
    } finally {
      setLoadingExcel(false); // hide loader
    }
  };


  const exportToCSV = async () => {
    try {
      setLoading(true); // show loader

      const stateCode = stateValue ? String(stateValue) : "0";
      const districtCode = districtValue ? String(districtValue) : "0";

      // 🔹 API call
      let result = await axios.post(
        `${process.env.NODE_ENV === 'development'
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
        }/api/GT/GetSchemeCount`,
        {
          flag: 55,
          schemeName: selectedSchemeWiseData,
          stateCode: stateCode,
          districtCode: districtCode,
          financialYear: finacialYearValue,
        }
      );

      if (!result.data.success || !result.data.dataContent || result.data.dataContent.length === 0) {
        alert("No data found for export.");
        return;
      }

      const apiData = result.data.dataContent;

      // 🔹 Group data by scheme → state → district
      const grouped = {};
      apiData.forEach(item => {
        const scheme = item.schemeName;
        const state = item.stateName;
        const district = item.districtName;
        const total = Number(item.totalSurvey) || 0;

        if (!grouped[scheme]) grouped[scheme] = {};
        if (!grouped[scheme][state]) grouped[scheme][state] = { total: 0, districts: {} };

        grouped[scheme][state].total += total;
        grouped[scheme][state].districts[district] = total;
      });

      // 🔹 Build CSV content
      let csvContent = "";
      Object.keys(grouped).forEach(scheme => {
        csvContent += `\nScheme Name: ${scheme}\n\n`;
        csvContent += "State Name,Total Surveys\n";

        Object.keys(grouped[scheme]).forEach(state => {
          const stateData = grouped[scheme][state];
          csvContent += `${state},${stateData.total}\n`;

          // District breakdown
          csvContent += "District Name,Total Surveys\n";
          Object.keys(stateData.districts).forEach(district => {
            csvContent += `${district},${stateData.districts[district]}\n`;
          });
          csvContent += "\n"; // spacing after each state
        });

        csvContent += "\n"; // spacing after each scheme
      });

      // 🔹 Trigger download
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'survey_data.csv';
      a.click();
      URL.revokeObjectURL(url);

    } catch (error) {
      console.error("Error exporting CSV:", error);
      alert("Failed to export CSV. Please try again.");
    } finally {
      setLoading(false); // hide loader
    }
  };




  const filterData = async () => {
    setLoaderSurveyData(true);
    setsurveyData([]);

    // Ensure values are either strings or "0" if empty
    const stateCode = stateValue ? String(stateValue) : "0";
    const districtCode = districtValue ? String(districtValue) : "0";
    const subDistrictCode = subDistrictValue ? String(subDistrictValue) : "0";
    const blockCode = blockValue ? String(blockValue) : "0";
    const villageCode = villageValue ? String(villageValue) : "0";
    const status = statusValue ? String(statusValue) : "0"; // Rename local variable
    let flag = 0;
    if (stateCode !== "0") {
      // alert(stateCode);
      flag = 2;
    }
    if (districtCode !== "0") {
      // alert(districtCode);
      flag = 1;
    }
    try {
      let result = await axios.post(
        `${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSchemeCount`,

        {
          "flag": 0,
          "schemeName": selectedSchemeWiseData,
          "stateCode": stateCode,
          "districtCode": districtCode,
          "financialYear": finacialYearValue
        }

      );

      if (result.data.success === true) {
        setsurveyData(result.data.dataContent);
        console.log("Data:", result.data.dataContent);
      } else {
        console.log("No data found.");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsFetching(false);
      setLoaderSurveyData(false);
    }
  };



  function handleVillage(value) {
    // setSubDistrictValue(value);

    if (value === "NA") {
      return;
    }

    var raw = JSON.stringify({
      blockcode: blockValue,
    });

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEV_MODE
        : process.env.REACT_APP_PRO_MODE
      }/api/village`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => setVillageData(JSON.parse(result).dataContent))
      .catch((error) => console.log("error", error));
  }


  function handleBlock(value) {
    setSubDistrictValue(value);
    if (value === "NA") {
      return;
    }

    var raw = JSON.stringify({
      subdistrictcode: value,
      districtcode: districtValue,
    });

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEV_MODE
        : process.env.REACT_APP_PRO_MODE
      }/api/block`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => setBlockData(JSON.parse(result).dataContent))
      .catch((error) => console.log("error", error));
  }

  function handleSubDistrict(value, DDValue) {

    setDistrictValue(value);

    if (value === "NA") {
      return;
    }
    if (value != null) {
      var raw = JSON.stringify({
        // subdistrictcode: value,
        districtcode: value,
      });
    } else {
      var raw = JSON.stringify({
        // subdistrictcode: value,
        districtcode: districtValue,
      });
    }

    // setSubDistrictValue(value);
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEV_MODE
        : process.env.REACT_APP_PRO_MODE
      }/api/subdistrict`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => setSubDistrictData(JSON.parse(result).dataContent))
      .catch((error) => console.log("error", error));
  }


  // Extract unique filter values
  const states = useMemo(() => [...new Set(surveyData.map(item => item.stateName))], [surveyData]);
  const districts = useMemo(() => [...new Set(surveyData.filter(item => item.stateName === selectedState).map(item => item.districtName))], [surveyData, selectedState]);
  const subDistricts = useMemo(() => [...new Set(surveyData.filter(item => item.districtName === selectedDistrict).map(item => item.subDistrictName))], [surveyData, selectedDistrict]);
  const blocks = useMemo(() => [...new Set(surveyData.filter(item => item.subDistrictName === selectedSubDistrict).map(item => item.blockName))], [surveyData, selectedSubDistrict]);
  const villages = useMemo(() => [...new Set(surveyData.filter(item => item.blockName === selectedBlock).map(item => item.villageName))], [surveyData, selectedBlock]);


  return (
    <main id="main" className="main SurveyData">


      {/* Tab Navigation */}
      <ul className="nav nav-tabs">
        <li className="nav-item active">
          <button
            className={`nav-link ${["dashboard", "stateWiseData", "districtWiseData","tableWiseData"].includes(activeTab) ? "active" : ""}`}
            onClick={() => setActiveTab("dashboard")}
          > Central Dashboard
          </button>

        </li>
        
        {/* <li className="nav-item">
          <button className={`nav-link ${activeTab === "test" ? "active" : ""}`} onClick={() => setActiveTab("test")}>
            Scheme Wise  Dashboard
          </button>
        </li> */}
        {(activeTab === "districtWiseData" || activeTab === "tableWiseData") && activeTab != "tableWiseData" && (
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "districtWiseData" ? "active" : ""}`}
              onClick={async () => {
                const schemeToUse = (selectedSchemeWiseData && selectedSchemeWiseData !== "NA")
                  ? selectedSchemeWiseData
                  : selectedScheme;
                const stateToUse = stateValue || stateCodeValue;
                setActiveTab("tableWiseData");
                const data = await getSurveyDataTableView(schemeToUse, stateToUse, finacialYearValue);
                setSurveyTableData(data);
              }}
            >
              Table View
            </button>
          </li>
        )}
        <li> {activeTab != 'dashboard' && activeTab != 'tableWiseData' && (
          <button className='btn btn-success' onClick={() => backButton()}><i class="bi bi-arrow-90deg-left"></i>Back</button>
        )}</li>
      </ul>

      {/* Tab Content */}
      <div>
        {activeTab === "tableWiseData" && surveyTableData && (
          <SurveyDataTableView data={surveyTableData} />
        )}
        {activeTab === "dashboard" && (
          <>
            <div className="filterschemebg">
              <h5>Filter Data</h5>
              <div className="row">
                <div className="col-md-3">
                  <label>State</label>
                  <select
                    id="State"
                    required
                    className="form-select"
                    onClick={getStates}
                    onChange={(e) => handleState(e.target.value)}
                    value={stateValue}
                    name="stateCode"
                  >
                    <option defaultValue value="NA">Choose...</option>
                    {statesData
                      ? statesData.map((item, id) => {
                        return (
                          <option key={id} value={item.stateCode}>
                            {" "}
                            {item.stateName}
                          </option>
                        );
                      })
                      : ""}
                  </select>
                </div>
                <div className="col-md-3">
                  <label>District</label>
                  <select
                    id="District"
                    className="form-select"
                    onChange={(e) => handleSubDistrict(e.target.value)}
                    value={districtValue}
                  >
                    <option defaultValue value="NA">
                      Choose...
                    </option>

                    {districtData
                      ? districtData.map((item, id) => {
                        return (
                          <option key={id} value={item.districtCode}>
                            {" "}
                            {item.districtName}
                          </option>
                        );
                      })
                      : ""}
                  </select>
                </div>
                <div className="col-md-3">
                  <label
                    htmlFor="subDistrict"

                    id="subDistrictLabel"
                  >
                    SubDistrict
                  </label>
                  <select
                    id="subDistrict"
                    className="form-select"
                    onChange={(e) => handleBlock(e.target.value)}
                    value={subDistrictValue}
                  >
                    <option defaultValue value="NA">
                      Choose...
                    </option>

                    {subDistrictData.map((item, id) => {
                      return (
                        <option key={id} value={item.subDistrictCode}>
                          {" "}
                          {item.subDistrictName}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="col-md-3">
                  <label
                    htmlFor="subDistrict"
                    id="subDistrictLabel"
                  >Financial Year</label>
                  <select
                    id="District"
                    className="form-select"
                    value={finacialYearValue}
                    onChange={handleFinancialYearChange}
                  >
                    <option value="">
                      All Financial Year
                    </option>
                    <option value="2026">2026-2027</option>
                    <option value="2025">2025-2026</option>
                    <option value="2024">2024-2025</option>
                    <option value="2023">2023-2024</option>
                  </select>
                </div>
                <div className="col-md-3">
                  <label
                    htmlFor="subDistrict"
                    className="form-label"
                    id="subDistrictLabel"
                  >
                    Scheme
                  </label>
                  <select
                    id="District"
                    className="form-select"
                    value={selectedSchemeWiseData}
                    onChange={handleSchemeWiseChange}
                  >
                    <option defaultValue value="NA">
                      Select Scheme
                    </option>
                    <option value="ACABC">ACABC</option>
                    <option value="ACABC (Agriventure) ">ACABC (Agriventure) </option>
                    <option value="ACABC (Nodal Training Institute)">ACABC (Nodal Training Institute)</option>
                    <option value="Agri Infra Fund">Agri Infra Fund</option>
                    <option value="Agroforestry">Agroforestry</option>
                    <option value="Agriculture Marketing Infrastructure()">Agriculture Marketing Infrastructure(AMI)</option>
                    <option value="Crop Health (CH)">Crop Health (CH)</option>
                    <option value="CIH">CIH</option> 
                    <option value="Coconut Development Board (CDB)">Coconut Development Board (CDB)</option>
                    <option value="Cropic-Pradhan Mantri Fasal Bima Yojana (PMFBY)">Cropic-Pradhan Mantri Fasal Bima Yojana (PMFBY)</option>
                    <option value="Directorate of Arecanut and Spices Development (DASD)">Directorate of Arecanut and Spices Development (DASD)</option>
                    <option value="Ground Truthing (GT)">Ground Truthing (GT)</option>
                    {/* <option value="M&T - CHC (FMDBT)">M&T - CHC (FMDBT)</option> */}
                    <option value="M&T - CHC (Farms App)">M&T - CHC (Farms App)</option>
                    <option value="MT-SMAM">M&T-SMAM</option>
                    <option value="MT-CRM">M&T-CRM</option>
                    <option value="Mission Organic Value Chain Development (MOVCD)">Mission Organic Value Chain Development (MOVCD)</option>
                    <option value="Mission for Integrated Development of Horticulture (MIDH)">Mission for Integrated Development of Horticulture (MIDH)</option>

                    <option value="(NFSM) CFLD">(NFSM) CFLD</option>
                    <option value="(NFSM) SD">(NFSM) SD</option>
                    <option value="(NFSM) FLD">(NFSM) FLD</option>
                    <option value="NFSM-HDPS Cotton">NFSM-HDPS Cotton</option>
                    <option value="Natural Farming(NF)">Natural Farming(NF)</option>
                    <option value="National Mission on Edible Oils (NMEO)-OS">National Mission on Edible Oils (NMEO)-OS</option>
                    <option value="National Mission on Edible Oils (NMEO)-OP">National Mission on Edible Oils (NMEO)-OP</option>
                    <option value="National Horticulture Board (NHB)-Inspection">National Horticulture Board (NHB)-Inspection</option>
                    <option value="National Beekeeping and Honey Mission (NBHM) (Honey Processing Unit)">National Beekeeping and Honey Mission (NBHM) (Honey Processing Unit)</option>
                    <option value="National Beekeeping and Honey Mission (NBHM) (Honey Testing Unit)">National Beekeeping and Honey Mission (NBHM) (Honey Testing Unit)</option>
                    <option value="National Beekeeping and Honey Mission (NBHM) (Honey CHC)">National Beekeeping and Honey Mission (NBHM) (Honey CHC)</option>
                    <option value="National Beekeeping and Honey Mission (NBHM) (Beeflora Plantation)">National Beekeeping and Honey Mission (NBHM) (Beeflora Plantation)</option>
                    <option value="Per Drop More Crop(PDMC)">Per Drop More Crop(PDMC)</option>
                    <option value="Paramparagat Krishi Vikas Yojana (PKVY)">Paramparagat Krishi Vikas Yojana (PKVY)</option>
                    <option value="Rainfed Area Development">Rainfed Area Development</option>
                    <option value="RKVY DPR">RKVY DPR</option>
                    <option value="RKVY (Bhuvan)">RKVY (Bhuvan)</option>
                    <option value="Seed Hub">Seed Hub</option>

                    <option value="Soil Testing Lab">Soil Testing Lab</option>
                    <option value="Soil Health Card (SHC)-Farmer">Soil Health Card (SHC)-Farmer</option>
                  </select>
                </div>
                <div className="col-md-3">
                  <label
                    htmlFor="umbrellaBased"
                    className="form-label"
                    id="umbrellaBasedLabel"
                  >Umbrella Based</label>
                  <select
                    id="umbrellaBased"
                    className="form-select"
                    value={selectedUmbrellaBasedData}
                    onChange={handleUmbrellaBased}
                  >
                    <option value="">Select Umbrella Based Scheme</option>
                    <option value="RKVY Umbrella">RKVY Umbrella</option>
                    <option value="KY Umbrella">KY Umbrella</option>
                    <option value="Other Schemes">Other Schemes</option>
                    <option value="demostration">Demonstration</option>
                  </select>

                </div>

                <div className="col-md-3">
                  <button className="btn btn-primary" style={{ marginTop: "30px" }} onClick={filterData}><i class="bi bi-check-lg"></i> Submit</button>
                  <button className="btn btn-success" style={{ marginTop: "30px", marginLeft: "10px" }} onClick={resetFields}><i class="bi bi-x-diamond-fill"></i> Reset</button>
                </div>

              </div>
            </div>

            <section className="section dashboard surveydatas mt-5">


              <div className="exportwrp">
                <button
                  className={`exportbtn nav-link ${activeTab === "districtWiseData" ? "active" : ""
                    }`}
                  onClick={async () => {

                    if (!selectedSchemeWiseData || !stateValue) {
                      alert("Please select State and Scheme first");
                      return;
                    }
                    //alert(selectedSchemeWiseData+'--'+stateValue);
                    setActiveTab("tableWiseData");
                    const data = await getSurveyDataTableView(
                      selectedSchemeWiseData,
                      stateValue,
                      finacialYearValue
                    );
                    setSurveyTableData(data);
                  }}
                >
                  Table View
                </button>

              </div>


              <div className="exportwrp">
                <button
                  className="exportbtncsv"
                  onClick={exportToCSV}
                  disabled={loading} // disable while loading
                >
                  {loading ? "Exporting..." : "Export to CSV"}
                </button>


              </div>

              <div className="exportwrp2">
                <button
                  className="exportbtn"
                  onClick={exportToExcel}
                  disabled={loadingExcel} // disable while loading
                >
                  {loadingExcel ? "Exporting..." : "Export to Excel"}
                </button>

                {loadingExcel && <div className="loader"></div>}
              </div>
              {!selectedUmbrellaBasedData ? (
                <div className=''>
                  <h4 className='headingsSurveydata'> Asset-Based Scheme</h4>
                  <div className="card-body">
                    <div className="row">
                      {surveyData.map((item, key) => {
                        if (item.schemeCode === 1) {
                          return (
                            <div key={key} className="col-xxl-3 col-md-3">
                              <div
                                className="card info-card sales-card bg-gradient-info card-img-holder"
                                onClick={() => {
                                  getStatesWiseData(item.schemeName);
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                <div className="card-body">
                                  <img src={Circles} className="card-img-absolute" alt="circle-image" />
                                  <div className="text-center">
                                    <div>
                                      <h6 >{item.totalSurvey}</h6>
                                    </div>
                                    <div>
                                      <h5 className="text-white">{item.schemeName}</h5>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        }
                        return null; // Return null if condition is not met (avoiding map issues)
                      })}
                    </div>

                    <h4 className='headingsSurveydata'>Subsidy-Based Scheme</h4>
                    <div className="row">
                      {surveyData.map((item, key) => {

                        if (item.schemeCode === 2) {
                          return (
                            <div key={key} className="col-xxl-3 col-md-3">
                              <div
                                className="card info-card sales-card bg-gradient-info card-img-holder"
                                onClick={() => getStatesWiseData(item.schemeName)}// Added inside div properly
                                style={{ cursor: "pointer" }} // To indicate clickability
                              >
                                <div className="card-body">
                                  <img src={Circles} className="card-img-absolute" alt="circle-image" />
                                  <div className="text-center">
                                    <div>
                                      <h6>{item.totalSurvey}</h6>
                                    </div>
                                    <div>
                                      <h5 className="text-white">{item.schemeName}</h5>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        }
                      })}
                    </div>

                    <h4 className='headingsSurveydata'>Others</h4>
                    <div className="row">
                      {surveyData.map((item, key) => {

                        if (item.schemeCode === 3) {
                          return (
                            <div key={key} className="col-xxl-3 col-md-3">
                              <div
                                className="card info-card sales-card bg-gradient-info card-img-holder"
                                onClick={() => getStatesWiseData(item.schemeName)}
                                style={{ cursor: "pointer" }}
                              >
                                <div className="card-body">
                                  <img src={Circles} className="card-img-absolute" alt="circle-image" />
                                  <div className="text-center">
                                    <div>
                                      <h6>{item.totalSurvey}</h6>
                                    </div>
                                    <div>
                                      <h5 className="text-white">{item.schemeName}</h5>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        }
                      })}
                    </div>

                  </div>
                </div>
              ) : (
                <div>
                  <h4 className="headingsSurveydata">{selectedUmbrellaBasedData}</h4>
                  <div className="card-body">
                    <div className="row">
                      {surveyData
                        .filter(
                          (item) =>
                            selectedUmbrellaBasedData === "RKVY Umbrella" &&
                            (
                              item.schemeName === "RKVY DPR" ||
                              item.schemeName === "Rashtriya Krishi Vikas Yojana (RKVY)" ||
                              item.schemeName === "Per Drop More Crop(PDMC)" ||
                              item.schemeName === "Soil Health Card (SHC)-Farmer" ||
                              item.schemeName === "Rainfed Area Development" ||
                              item.schemeName === "Agroforestry"
                            )
                        )

                        .sort((a, b) => a.schemeName.localeCompare(b.schemeName))
                        .map((item, key) => (
                          <div key={key} className="col-xxl-3 col-md-3">
                            <div
                              className="card info-card sales-card bg-gradient-info card-img-holder"
                              onClick={() => getStatesWiseData(item.schemeName)}
                              style={{ cursor: "pointer" }}
                            >
                              <div className="card-body">
                                <img src={Circles} className="card-img-absolute" alt="circle-image" />
                                <div className="text-center">
                                  <div>
                                    <h6>{item.totalSurvey}</h6>
                                  </div>
                                  <div>
                                    <h5 className="text-white">{item.schemeName}</h5>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}

                      {surveyData
                        .filter(
                          (item) =>
                            selectedUmbrellaBasedData === "KY Umbrella" &&
                            (
                              item.schemeName === "Agriculture Marketing Infrastructure()" ||
                              item.schemeName === "(NFSM) FLD" ||
                              item.schemeName === "(NFSM) SD" ||
                              item.schemeName === "National Mission on Edible Oils (NMEO)-OP" ||
                              item.schemeName === "National Mission on Edible Oils (NMEO)-OS" ||
                              item.schemeName === "Mission for Integrated Development of Horticulture (MIDH)" ||
                              item.schemeName === "MOVCD" ||
                              item.schemeName === "Agri Infra Fund" ||
                              item.schemeName === "Ground Truthing (GT)" ||
                              item.schemeName === "Crop Health"
                            )
                        )

                        .sort((a, b) => a.schemeName.localeCompare(b.schemeName))
                        .map((item, key) => (
                          <div key={key} className="col-xxl-3 col-md-3">
                            <div
                              className="card info-card sales-card bg-gradient-info card-img-holder"
                              onClick={() => getStatesWiseData(item.schemeName)}
                              style={{ cursor: "pointer" }}
                            >
                              <div className="card-body">
                                <img src={Circles} className="card-img-absolute" alt="circle-image" />
                                <div className="text-center">
                                  <div>
                                    <h6>{item.totalSurvey}</h6>
                                  </div>
                                  <div>
                                    <h5 className="text-white">{item.schemeName}</h5>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}

                      {selectedUmbrellaBasedData === "demostration"  && (
                        <div className='row'>
                        <div className="col-xxl-3 col-md-3">
                          <div
                            className="card info-card sales-card bg-gradient-success card-img-holder"
                            style={{ cursor: "pointer" }}
                            onClick={() => showNFSMCardsAction()}
                          >
                            <div className="card-body">
                              <img
                                src={Circles}
                                className="card-img-absolute"
                                alt="circle-image"
                              />
                              <div className="text-center">
                                <h6>{nfsmtotalSurvey}</h6>
                                <h5 className="text-white">NFSM</h5>
                                <small className="text-white opacity-7">
                                  Click to view schemes
                                </small>
                              </div>
                            </div>
                          </div>
                        </div>
                         <div className="col-xxl-3 col-md-3">
                          <div
                            className="card info-card sales-card bg-gradient-success card-img-holder"
                            style={{ cursor: "pointer" }}
                            onClick={() => showATMAardsAction()}
                          >
                            <div className="card-body">
                              <img
                                src={Circles}
                                className="card-img-absolute"
                                alt="circle-image"
                              />
                              <div className="text-center">
                                <h6>{atmatotalSurvey}</h6>
                                <h5 className="text-white">ATMA</h5>
                                <small className="text-white opacity-7">
                                  Click to view schemes
                                </small>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-xxl-3 col-md-3">
                          <div
                            className="card info-card sales-card bg-gradient-success card-img-holder"
                            style={{ cursor: "pointer" }}
                            onClick={() => showMOVCDCardsAction()}
                          >
                            <div className="card-body">
                              <img
                                src={Circles}
                                className="card-img-absolute"
                                alt="circle-image"
                              />
                              <div className="text-center">
                                <h6>{movcdtotalSurvey}</h6>
                                <h5 className="text-white">MOVCD</h5>
                                <small className="text-white opacity-7">
                                  Click to view schemes
                                </small>
                              </div>
                            </div>
                          </div>
                        </div>
                         <div className="col-xxl-3 col-md-3">
                          <div
                            className="card info-card sales-card bg-gradient-success card-img-holder"
                            style={{ cursor: "pointer" }}
                            onClick={() => showMIDHCardsAction()}
                          >
                            <div className="card-body">
                              <img
                                src={Circles}
                                className="card-img-absolute"
                                alt="circle-image"
                              />
                              <div className="text-center">
                                <h6>{midhtotalSurvey}</h6>
                                <h5 className="text-white">MIDH</h5>
                                <small className="text-white opacity-7">
                                  Click to view schemes
                                </small>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-xxl-3 col-md-3">
                          <div
                            className="card info-card sales-card bg-gradient-success card-img-holder"
                            style={{ cursor: "pointer" }}
                            onClick={() => showRKVYCardsAction()}
                          >
                            <div className="card-body">
                              <img
                                src={Circles}
                                className="card-img-absolute"
                                alt="circle-image"
                              />
                              <div className="text-center">
                                <h6>{rkvytotalSurvey}</h6>
                                <h5 className="text-white">RKVY DPR</h5>
                                <small className="text-white opacity-7">
                                  Click to view schemes
                                </small>
                              </div>
                            </div>
                          </div>
                        </div>
                        </div>
                      )}

                      {showRKVYCards &&
                        surveyData
                          .filter(
                            item =>
                              selectedUmbrellaBasedData === "demostration" &&
                              RKVY_SCHEMES.includes(item.schemeName)
                          )
                          .sort((a, b) => a.schemeName.localeCompare(b.schemeName))
                          .map((item, key) => (
                            <div key={key} className="col-xxl-3 col-md-3 divideline">
                              <div
                                className="card mt-2 info-card sales-card bg-gradient-info card-img-holder"
                                onClick={() => getStatesWiseData(item.schemeName)}
                                style={{ cursor: "pointer" }}
                              >
                                <div className="card-body">
                                  <img
                                    src={Circles}
                                    className="card-img-absolute"
                                    alt="circle-image"
                                  />
                                  <div className="text-center">
                                    <h6>{item.totalSurvey}</h6>
                                    <h5 className="text-white">{item.schemeName}</h5>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}

                      {showNFSMCards &&
                        surveyData
                          .filter(
                            item =>
                              selectedUmbrellaBasedData === "demostration" &&
                              NFSM_SCHEMES.includes(item.schemeName)
                          )
                          .sort((a, b) => a.schemeName.localeCompare(b.schemeName))
                          .map((item, key) => (
                            <div key={key} className="col-xxl-3 col-md-3 divideline">
                              <div
                                className="card mt-2 info-card sales-card bg-gradient-info card-img-holder"
                                onClick={() => getStatesWiseData(item.schemeName)}
                                style={{ cursor: "pointer" }}
                              >
                                <div className="card-body">
                                  <img
                                    src={Circles}
                                    className="card-img-absolute"
                                    alt="circle-image"
                                  />
                                  <div className="text-center">
                                    <h6>{item.totalSurvey}</h6>
                                    <h5 className="text-white">{item.schemeName}</h5>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}

                           {showMIDHCards &&
                        surveyData
                          .filter(
                            item =>
                              selectedUmbrellaBasedData === "demostration" &&
                              MIDH_SCHEMES.includes(item.schemeName)
                          )
                          .sort((a, b) => a.schemeName.localeCompare(b.schemeName))
                          .map((item, key) => (
                            <div key={key} className="col-xxl-3 col-md-3 divideline">
                              <div
                                className="card mt-2 info-card sales-card bg-gradient-info card-img-holder"
                                onClick={() => getStatesWiseData(item.schemeName)}
                                style={{ cursor: "pointer" }}
                              >
                                <div className="card-body">
                                  <img
                                    src={Circles}
                                    className="card-img-absolute"
                                    alt="circle-image"
                                  />
                                  <div className="text-center">
                                    <h6>{item.totalSurvey}</h6>
                                    <h5 className="text-white">{item.schemeName}</h5>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}

                           {showATMACards &&
                        surveyData
                          .filter(
                            item =>
                              selectedUmbrellaBasedData === "demostration" &&
                              ATMA_SCHEMES.includes(item.schemeName)
                          )
                          .sort((a, b) => a.schemeName.localeCompare(b.schemeName))
                          .map((item, key) => (
                            <div key={key} className="col-xxl-3 col-md-3 divideline">
                              <div
                                className="card mt-2 info-card sales-card bg-gradient-info card-img-holder"
                                onClick={() => getStatesWiseData(item.schemeName)}
                                style={{ cursor: "pointer" }}
                              >
                                <div className="card-body">
                                  <img
                                    src={Circles}
                                    className="card-img-absolute"
                                    alt="circle-image"
                                  />
                                  <div className="text-center">
                                    <h6>{item.totalSurvey}</h6>
                                    <h5 className="text-white">{item.schemeName}</h5>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}

                              {showMOVCDCards &&
                        surveyData
                          .filter(
                            item =>
                              selectedUmbrellaBasedData === "demostration" &&
                              MOVCD_SCHEMES.includes(item.schemeName)
                          )
                          .sort((a, b) => a.schemeName.localeCompare(b.schemeName))
                          .map((item, key) => (
                            <div key={key} className="col-xxl-3 col-md-3 divideline">
                              <div
                                className="card mt-2 info-card sales-card bg-gradient-info card-img-holder"
                                onClick={() => getStatesWiseData(item.schemeName)}
                                style={{ cursor: "pointer" }}
                              >
                                <div className="card-body">
                                  <img
                                    src={Circles}
                                    className="card-img-absolute"
                                    alt="circle-image"
                                  />
                                  <div className="text-center">
                                    <h6>{item.totalSurvey}</h6>
                                    <h5 className="text-white">{item.schemeName}</h5>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}




                      {surveyData
                        .filter(
                          (item) =>
                            selectedUmbrellaBasedData === "Other Schemes" &&
                            (
                              item.schemeName === "National Beekeeping and Honey Mission (NBHM) (Beeflora Plantation)" ||
                              item.schemeName === "National Beekeeping and Honey Mission (NBHM) (Honey Testing Unit)" ||
                              item.schemeName === "National Beekeeping and Honey Mission (NBHM) (Honey Processing Unit)" ||
                              item.schemeName === "National Beekeeping and Honey Mission (NBHM) (Honey CHC)" ||
                              item.schemeName === "Directorate of Arecanut and Spices Development (DASD)" ||
                              item.schemeName === "Directorate of Cashewnut and Cocoa Development (DCCD)"
                            )
                        )
                        .sort((a, b) => a.schemeName.localeCompare(b.schemeName))
                        .map((item, key) => (
                          <div key={key} className="col-xxl-3 col-md-3">
                            <div
                              className="card info-card sales-card bg-gradient-info card-img-holder"
                              onClick={() => getStatesWiseData(item.schemeName)}
                              style={{ cursor: "pointer" }}
                            >
                              <div className="card-body">
                                <img src={Circles} className="card-img-absolute" alt="circle-image" />
                                <div className="text-center">
                                  <div>
                                    <h6>{item.totalSurvey}</h6>
                                  </div>
                                  <div>
                                    <h5 className="text-white">{item.schemeName}</h5>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}

                    </div>
                  </div>
                </div>
              )}
            </section>
          </>
        )}
        {activeTab === "stateWiseData" && (() => {

          // Group states and sum totalSurvey values
          const aggregatedData = selectedSchemeData.reduce((acc, item) => {
            if (item.stateName) { // Ensure stateName is not null
              if (!acc[item.stateName]) {
                acc[item.stateName] = {
                  stateName: item.stateName,
                  schemeName: item.schemeName,
                  stateCode: Number(item.stateCode),
                  totalSurvey: Number(item.totalSurvey)
                };
              } else {
                acc[item.stateName].totalSurvey += Number(item.totalSurvey);
              }
            }
            return acc;
          }, {});

          // Convert object to array
          let groupedData = Object.values(aggregatedData);

          // Sort the data in descending order based on totalSurvey
          groupedData.sort((a, b) => b.totalSurvey - a.totalSurvey);

          // Calculate total survey count across all states
          const totalSurveyAllStates = groupedData.reduce((sum, state) => sum + state.totalSurvey, 0);

          return (
            <>
              <div className="total-survey-card filterschemebg">
                <div className="text-center">
                  <h5 className="text-black">State Reports</h5>
                  <h5 className="text-black"><b>{selectedScheme}</b></h5>
                  <h5 className="text-black">Total Surveys: {totalSurveyAllStates}</h5>
                  <b>{finacialYearValue === '2025'
                    ? '2025-2026'
                    : finacialYearValue === '2024'
                      ? '2024-2025'
                      : finacialYearValue === '2023'
                        ? '2023-2024'
                        : 'All finacial Year'}</b>

                </div>
              </div>




              {/* State-wise Survey Data */}
              <div className="row">
                {groupedData.map((item, key) => (
                  <div key={key} className="col-xxl-3 col-md-3" onClick={() => getdistrictWiseData(item.schemeName, item.stateCode, item.stateName)} style={{ cursor: "pointer" }}>
                    <div className="card info-card sales-card bg-gradient-info card-img-holder">
                      <div className="card-body">
                        <img src={Circles} className="card-img-absolute" alt="circle-image" />
                        <div className="text-center">
                          <div>
                            <h6 className='totalitm'>{item.stateName}</h6>
                          </div>
                          <div>
                            <h5 className="text-white">{item.totalSurvey}</h5> {/* Summed and sorted value */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          );
        })()}


        {activeTab === "districtWiseData" && (() => {
          // Group states and sum totalSurvey values
          const aggregatedData = selectedSateData.reduce((acc, item) => {
            if (item.districtName) { // Ensure stateName is not null
              if (!acc[item.districtName]) {
                acc[item.districtName] = {
                  districtName: item.districtName,
                  schemeName: item.schemeName,
                  stateName: item.stateName,
                  totalSurvey: Number(item.totalSurvey)
                };
              } else {
                acc[item.districtName].totalSurvey += Number(item.totalSurvey);
              }
            }
            return acc;
          }, {});

          // Convert object to array
          let groupedData = Object.values(aggregatedData);

          // Sort the data in descending order based on totalSurvey
          groupedData.sort((a, b) => b.totalSurvey - a.totalSurvey);

          // Calculate total survey count across all states
          const totalSurveyAllStates = groupedData.reduce((sum, state) => sum + state.totalSurvey, 0);

          return (
            <>
              <div className="total-survey-card mt-5 filterschemebg mb-4">
                <div className="card-body text-center">
                  <h5 className="text-black">District Reports</h5>
                  <h5 className="text-black"><b>{selectedScheme}</b> <b className='statenme'>({selectedSateScheme})</b></h5>
                  <h5 className="text-black">Total Surveys: {totalSurveyAllStates}</h5>
                  <b>{finacialYearValue === '2025'
                    ? '2025-2026'
                    : finacialYearValue === '2024'
                      ? '2024-2025'
                      : finacialYearValue === '2023'
                        ? '2023-2024'
                        : 'All finacial Year'}</b>

                </div>
              </div>




              {/* State-wise Survey Data */}
              <div className="row">
                {groupedData.map((item, key) => (
                  <div key={key} className="col-xxl-3 col-md-3"  >
                    <div className="card info-card sales-card bg-gradient-info card-img-holder">
                      <div className="card-body">
                        <img src={Circles} className="card-img-absolute" alt="circle-image" />
                        <div className="text-center">
                          <div>
                            <h6 className='totalitm'>{item.districtName}</h6>
                          </div>
                          <div>
                            <h5 className="text-white">{item.totalSurvey}</h5> {/* Summed and sorted value */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          );
        })()}




        {activeTab === "test" && (
          <section className="section  surveydatas">
            <div className="">
              {Array.from(new Set(surveySchemeData.map(item => item.schemeName))).map((scheme, index) => {
                // Filter data for the current scheme & remove entries where stateName is null or empty
                const schemeData = surveySchemeData
                  .filter(item => item.schemeName === scheme && item.stateName);

                // Aggregate totalSurvey for each state within this scheme
                const stateSurveyMap = schemeData.reduce((acc, item) => {
                  if (acc[item.stateName]) {
                    acc[item.stateName] += Number(item.totalSurvey);
                  } else {
                    acc[item.stateName] = Number(item.totalSurvey);
                  }
                  return acc;
                }, {});

                // Convert aggregated object to array and sort by totalSurvey descending
                const topStates = Object.entries(stateSurveyMap)
                  .map(([stateName, totalSurvey]) => ({ stateName, totalSurvey }))
                  .sort((a, b) => b.totalSurvey - a.totalSurvey)
                  .slice(0, 5); // Select top 5 states

                return (
                  <div key={index}>
                    <h4 className="headingsSurveydata mt-5">{scheme}</h4>
                    <div className="card-body">
                      <div className="row gap-2 justify-content-center">
                        {topStates.map((stateData, i) => (
                          <div key={i} className="col-xxl-2 col-md-2 p-0">
                            <div className="card info-card sales-card bg-gradient-info card-img-holder p-2" style={{ height: "90px", width: "100%", marginTop: "16px" }}>
                              <div className="card-body p-2">
                                <img src={Circles} className="card-img-absolute" alt="circle-image" />
                                <div className="text-center">
                                  <div>
                                    <h6 className="mb-1" >{stateData.stateName}</h6>
                                  </div>
                                  <div>
                                    <h5 className="text-white" style={{ fontSize: "16px" }}>Total Survey: {stateData.totalSurvey}</h5>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </section>
        )}





      </div>

      {LoaderSurveyData && (
        <div className="overlay">
          <div className="overlay__inner">
            <div className="overlay__content"><span className="spinner"></span></div>
          </div>
        </div>
      )}
    </main>
  );
}

export default SurveyData;